import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _154027fa = () => interopDefault(import('../pages/AboutUs.vue' /* webpackChunkName: "pages/AboutUs" */))
const _6c3c65f5 = () => interopDefault(import('../server/blog/BlogView.vue' /* webpackChunkName: "" */))
const _1546f906 = () => interopDefault(import('../pages/Budget.vue' /* webpackChunkName: "pages/Budget" */))
const _915b10a2 = () => interopDefault(import('../modules/checkout/pages/Cart.vue' /* webpackChunkName: "" */))
const _759d9ffa = () => interopDefault(import('../pages/CategoriesPage.vue' /* webpackChunkName: "" */))
const _7621f355 = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _2fc68f41 = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _94cc02d0 = () => interopDefault(import('../pages/Contact.vue' /* webpackChunkName: "pages/Contact" */))
const _1b42c905 = () => interopDefault(import('../pages/Coupons.vue' /* webpackChunkName: "pages/Coupons" */))
const _12095028 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _0ec47b5a = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _5a8d03ca = () => interopDefault(import('../modules/customer/pages/MyAccount/MyNewsletter.vue' /* webpackChunkName: "" */))
const _6d854d56 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _15751ada = () => interopDefault(import('../modules/customer/pages/MyAccount/MyReviews.vue' /* webpackChunkName: "" */))
const _cf398dd4 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyWishlist.vue' /* webpackChunkName: "" */))
const _50f4eb9a = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _341acba6 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _5f43b9f4 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _2ccd2319 = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _02e031f7 = () => interopDefault(import('../pages/ProductReturn.vue' /* webpackChunkName: "" */))
const _32e6f417 = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "" */))
const _8c3a2ae4 = () => interopDefault(import('../pages/Faq.vue' /* webpackChunkName: "pages/Faq" */))
const _e609150c = () => interopDefault(import('../pages/ShippingDelivery.vue' /* webpackChunkName: "" */))
const _1658cc7f = () => interopDefault(import('../pages/LinktreePage.vue' /* webpackChunkName: "pages/LinktreePage" */))
const _8eff3ba0 = () => interopDefault(import('../pages/Refund.vue' /* webpackChunkName: "" */))
const _f9c7ec72 = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _1f1eff8c = () => interopDefault(import('../pages/ReturnPolicy.vue' /* webpackChunkName: "" */))
const _1ed67452 = () => interopDefault(import('../pages/PrivacyPolicy.vue' /* webpackChunkName: "" */))
const _25f560d4 = () => interopDefault(import('../pages/ProductPage.vue' /* webpackChunkName: "pages/ProductPage" */))
const _876d67d6 = () => interopDefault(import('../modules/customer/pages/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _6f3ea656 = () => interopDefault(import('../pages/SearchResultsPage.vue' /* webpackChunkName: "pages/SearchResultsPage" */))
const _6431c08d = () => interopDefault(import('../pages/WorkWithUS.vue' /* webpackChunkName: "" */))
const _08c2104d = () => interopDefault(import('../pages/post/BlogForm.vue' /* webpackChunkName: "" */))
const _fb28c2c2 = () => interopDefault(import('../modules/checkout/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _63dd0673 = () => interopDefault(import('../pages/post/_slug.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/AboutUs",
    component: _154027fa,
    name: "AboutUs___default"
  }, {
    path: "/blog",
    component: _6c3c65f5
  }, {
    path: "/Budget",
    component: _1546f906,
    name: "Budget___default"
  }, {
    path: "/cart",
    component: _915b10a2,
    name: "cart___default"
  }, {
    path: "/categories",
    component: _759d9ffa,
    name: "categories___default"
  }, {
    path: "/CategoriesPage",
    component: _759d9ffa,
    name: "CategoriesPage___default"
  }, {
    path: "/checkout",
    component: _7621f355,
    name: "checkout___default"
  }, {
    path: "/Cms",
    component: _2fc68f41,
    name: "Cms___default"
  }, {
    path: "/Contact",
    component: _94cc02d0,
    name: "Contact___default"
  }, {
    path: "/Coupons",
    component: _1b42c905,
    name: "Coupons___default"
  }, {
    path: "/cupons",
    component: _1b42c905,
    name: "cupons___default"
  }, {
    path: "/customer",
    component: _12095028,
    meta: {"titleLabel":"My Account"},
    name: "customer___default",
    children: [{
      path: "addresses-details",
      component: _0ec47b5a,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___default"
    }, {
      path: "my-newsletter",
      component: _5a8d03ca,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___default"
    }, {
      path: "my-profile",
      component: _6d854d56,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___default"
    }, {
      path: "my-reviews",
      component: _15751ada,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___default"
    }, {
      path: "my-wishlist",
      component: _cf398dd4,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___default"
    }, {
      path: "order-history",
      component: _50f4eb9a,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___default"
    }, {
      path: "addresses-details/create",
      component: _341acba6,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___default"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _5f43b9f4,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___default"
    }, {
      path: "order-history/:orderId",
      component: _2ccd2319,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___default"
    }]
  }, {
    path: "/devolucao",
    component: _02e031f7,
    name: "devolução___default"
  }, {
    path: "/en",
    component: _32e6f417,
    name: "home___en"
  }, {
    path: "/fale-conosco",
    component: _94cc02d0,
    name: "contato___default"
  }, {
    path: "/Faq",
    component: _8c3a2ae4,
    name: "Faq___default"
  }, {
    path: "/frete-entrega",
    component: _e609150c,
    name: "frete e entrega___default"
  }, {
    path: "/german",
    component: _32e6f417,
    name: "home___german"
  }, {
    path: "/Home",
    component: _32e6f417,
    name: "Home___default"
  }, {
    path: "/LinktreePage",
    component: _1658cc7f,
    name: "LinktreePage___default"
  }, {
    path: "/orcamento",
    component: _1546f906,
    name: "orçamento___default"
  }, {
    path: "/pagamentos-e-reembolso",
    component: _8eff3ba0,
    name: "pagamento e reembolso___default"
  }, {
    path: "/Page",
    component: _f9c7ec72,
    name: "Page___default"
  }, {
    path: "/politica-devolucao",
    component: _1f1eff8c,
    name: "politica de troca e devolução___default"
  }, {
    path: "/privacidade",
    component: _1ed67452,
    name: "politica de privacidade___default"
  }, {
    path: "/PrivacyPolicy",
    component: _1ed67452,
    name: "PrivacyPolicy___default"
  }, {
    path: "/ProductPage",
    component: _25f560d4,
    name: "ProductPage___default"
  }, {
    path: "/ProductReturn",
    component: _02e031f7,
    name: "ProductReturn___default"
  }, {
    path: "/produto",
    component: _25f560d4,
    name: "product___default"
  }, {
    path: "/Refund",
    component: _8eff3ba0,
    name: "Refund___default"
  }, {
    path: "/reset-password",
    component: _876d67d6,
    name: "reset-password___default"
  }, {
    path: "/ReturnPolicy",
    component: _1f1eff8c,
    name: "ReturnPolicy___default"
  }, {
    path: "/SearchResultsPage",
    component: _6f3ea656,
    name: "SearchResultsPage___default"
  }, {
    path: "/ShippingDelivery",
    component: _e609150c,
    name: "ShippingDelivery___default"
  }, {
    path: "/sobre-nos",
    component: _154027fa,
    name: "sobre nós___default"
  }, {
    path: "/trabalhe-conosco",
    component: _6431c08d,
    name: "trabalhe conosco___default"
  }, {
    path: "/WorkWithUS",
    component: _6431c08d,
    name: "WorkWithUS___default"
  }, {
    path: "/blog/create",
    component: _08c2104d
  }, {
    path: "/checkout/success",
    component: _fb28c2c2,
    name: "checkout-success___default"
  }, {
    path: "/en/AboutUs",
    component: _154027fa,
    name: "AboutUs___en"
  }, {
    path: "/en/blog",
    component: _6c3c65f5
  }, {
    path: "/en/Budget",
    component: _1546f906,
    name: "Budget___en"
  }, {
    path: "/en/cart",
    component: _915b10a2,
    name: "cart___en"
  }, {
    path: "/en/categories",
    component: _759d9ffa,
    name: "categories___en"
  }, {
    path: "/en/CategoriesPage",
    component: _759d9ffa,
    name: "CategoriesPage___en"
  }, {
    path: "/en/checkout",
    component: _7621f355,
    name: "checkout___en"
  }, {
    path: "/en/Cms",
    component: _2fc68f41,
    name: "Cms___en"
  }, {
    path: "/en/Contact",
    component: _94cc02d0,
    name: "Contact___en"
  }, {
    path: "/en/Coupons",
    component: _1b42c905,
    name: "Coupons___en"
  }, {
    path: "/en/cupons",
    component: _1b42c905,
    name: "cupons___en"
  }, {
    path: "/en/customer",
    component: _12095028,
    meta: {"titleLabel":"My Account"},
    name: "customer___en",
    children: [{
      path: "addresses-details",
      component: _0ec47b5a,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___en"
    }, {
      path: "my-newsletter",
      component: _5a8d03ca,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___en"
    }, {
      path: "my-profile",
      component: _6d854d56,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___en"
    }, {
      path: "my-reviews",
      component: _15751ada,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___en"
    }, {
      path: "my-wishlist",
      component: _cf398dd4,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___en"
    }, {
      path: "order-history",
      component: _50f4eb9a,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___en"
    }, {
      path: "addresses-details/create",
      component: _341acba6,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___en"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _5f43b9f4,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___en"
    }, {
      path: "order-history/:orderId",
      component: _2ccd2319,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___en"
    }]
  }, {
    path: "/en/devolucao",
    component: _02e031f7,
    name: "devolução___en"
  }, {
    path: "/en/fale-conosco",
    component: _94cc02d0,
    name: "contato___en"
  }, {
    path: "/en/Faq",
    component: _8c3a2ae4,
    name: "Faq___en"
  }, {
    path: "/en/frete-entrega",
    component: _e609150c,
    name: "frete e entrega___en"
  }, {
    path: "/en/Home",
    component: _32e6f417,
    name: "Home___en"
  }, {
    path: "/en/LinktreePage",
    component: _1658cc7f,
    name: "LinktreePage___en"
  }, {
    path: "/en/orcamento",
    component: _1546f906,
    name: "orçamento___en"
  }, {
    path: "/en/pagamentos-e-reembolso",
    component: _8eff3ba0,
    name: "pagamento e reembolso___en"
  }, {
    path: "/en/Page",
    component: _f9c7ec72,
    name: "Page___en"
  }, {
    path: "/en/politica-devolucao",
    component: _1f1eff8c,
    name: "politica de troca e devolução___en"
  }, {
    path: "/en/privacidade",
    component: _1ed67452,
    name: "politica de privacidade___en"
  }, {
    path: "/en/PrivacyPolicy",
    component: _1ed67452,
    name: "PrivacyPolicy___en"
  }, {
    path: "/en/ProductPage",
    component: _25f560d4,
    name: "ProductPage___en"
  }, {
    path: "/en/ProductReturn",
    component: _02e031f7,
    name: "ProductReturn___en"
  }, {
    path: "/en/produto",
    component: _25f560d4,
    name: "product___en"
  }, {
    path: "/en/Refund",
    component: _8eff3ba0,
    name: "Refund___en"
  }, {
    path: "/en/reset-password",
    component: _876d67d6,
    name: "reset-password___en"
  }, {
    path: "/en/ReturnPolicy",
    component: _1f1eff8c,
    name: "ReturnPolicy___en"
  }, {
    path: "/en/SearchResultsPage",
    component: _6f3ea656,
    name: "SearchResultsPage___en"
  }, {
    path: "/en/ShippingDelivery",
    component: _e609150c,
    name: "ShippingDelivery___en"
  }, {
    path: "/en/sobre-nos",
    component: _154027fa,
    name: "sobre nós___en"
  }, {
    path: "/en/trabalhe-conosco",
    component: _6431c08d,
    name: "trabalhe conosco___en"
  }, {
    path: "/en/WorkWithUS",
    component: _6431c08d,
    name: "WorkWithUS___en"
  }, {
    path: "/german/AboutUs",
    component: _154027fa,
    name: "AboutUs___german"
  }, {
    path: "/german/blog",
    component: _6c3c65f5
  }, {
    path: "/german/Budget",
    component: _1546f906,
    name: "Budget___german"
  }, {
    path: "/german/cart",
    component: _915b10a2,
    name: "cart___german"
  }, {
    path: "/german/categories",
    component: _759d9ffa,
    name: "categories___german"
  }, {
    path: "/german/CategoriesPage",
    component: _759d9ffa,
    name: "CategoriesPage___german"
  }, {
    path: "/german/checkout",
    component: _7621f355,
    name: "checkout___german"
  }, {
    path: "/german/Cms",
    component: _2fc68f41,
    name: "Cms___german"
  }, {
    path: "/german/Contact",
    component: _94cc02d0,
    name: "Contact___german"
  }, {
    path: "/german/Coupons",
    component: _1b42c905,
    name: "Coupons___german"
  }, {
    path: "/german/cupons",
    component: _1b42c905,
    name: "cupons___german"
  }, {
    path: "/german/customer",
    component: _12095028,
    meta: {"titleLabel":"My Account"},
    name: "customer___german",
    children: [{
      path: "addresses-details",
      component: _0ec47b5a,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___german"
    }, {
      path: "my-newsletter",
      component: _5a8d03ca,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___german"
    }, {
      path: "my-profile",
      component: _6d854d56,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___german"
    }, {
      path: "my-reviews",
      component: _15751ada,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___german"
    }, {
      path: "my-wishlist",
      component: _cf398dd4,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___german"
    }, {
      path: "order-history",
      component: _50f4eb9a,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___german"
    }, {
      path: "addresses-details/create",
      component: _341acba6,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___german"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _5f43b9f4,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___german"
    }, {
      path: "order-history/:orderId",
      component: _2ccd2319,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___german"
    }]
  }, {
    path: "/german/devolucao",
    component: _02e031f7,
    name: "devolução___german"
  }, {
    path: "/german/fale-conosco",
    component: _94cc02d0,
    name: "contato___german"
  }, {
    path: "/german/Faq",
    component: _8c3a2ae4,
    name: "Faq___german"
  }, {
    path: "/german/frete-entrega",
    component: _e609150c,
    name: "frete e entrega___german"
  }, {
    path: "/german/Home",
    component: _32e6f417,
    name: "Home___german"
  }, {
    path: "/german/LinktreePage",
    component: _1658cc7f,
    name: "LinktreePage___german"
  }, {
    path: "/german/orcamento",
    component: _1546f906,
    name: "orçamento___german"
  }, {
    path: "/german/pagamentos-e-reembolso",
    component: _8eff3ba0,
    name: "pagamento e reembolso___german"
  }, {
    path: "/german/Page",
    component: _f9c7ec72,
    name: "Page___german"
  }, {
    path: "/german/politica-devolucao",
    component: _1f1eff8c,
    name: "politica de troca e devolução___german"
  }, {
    path: "/german/privacidade",
    component: _1ed67452,
    name: "politica de privacidade___german"
  }, {
    path: "/german/PrivacyPolicy",
    component: _1ed67452,
    name: "PrivacyPolicy___german"
  }, {
    path: "/german/ProductPage",
    component: _25f560d4,
    name: "ProductPage___german"
  }, {
    path: "/german/ProductReturn",
    component: _02e031f7,
    name: "ProductReturn___german"
  }, {
    path: "/german/produto",
    component: _25f560d4,
    name: "product___german"
  }, {
    path: "/german/Refund",
    component: _8eff3ba0,
    name: "Refund___german"
  }, {
    path: "/german/reset-password",
    component: _876d67d6,
    name: "reset-password___german"
  }, {
    path: "/german/ReturnPolicy",
    component: _1f1eff8c,
    name: "ReturnPolicy___german"
  }, {
    path: "/german/SearchResultsPage",
    component: _6f3ea656,
    name: "SearchResultsPage___german"
  }, {
    path: "/german/ShippingDelivery",
    component: _e609150c,
    name: "ShippingDelivery___german"
  }, {
    path: "/german/sobre-nos",
    component: _154027fa,
    name: "sobre nós___german"
  }, {
    path: "/german/trabalhe-conosco",
    component: _6431c08d,
    name: "trabalhe conosco___german"
  }, {
    path: "/german/WorkWithUS",
    component: _6431c08d,
    name: "WorkWithUS___german"
  }, {
    path: "/lp/links",
    component: _1658cc7f,
    name: "Links___default"
  }, {
    path: "/post/BlogForm",
    component: _08c2104d,
    name: "post-BlogForm___default"
  }, {
    path: "/en/blog/create",
    component: _08c2104d
  }, {
    path: "/en/checkout/success",
    component: _fb28c2c2,
    name: "checkout-success___en"
  }, {
    path: "/en/lp/links",
    component: _1658cc7f,
    name: "Links___en"
  }, {
    path: "/en/post/BlogForm",
    component: _08c2104d,
    name: "post-BlogForm___en"
  }, {
    path: "/german/blog/create",
    component: _08c2104d
  }, {
    path: "/german/checkout/success",
    component: _fb28c2c2,
    name: "checkout-success___german"
  }, {
    path: "/german/lp/links",
    component: _1658cc7f,
    name: "Links___german"
  }, {
    path: "/german/post/BlogForm",
    component: _08c2104d,
    name: "post-BlogForm___german"
  }, {
    path: "/en/blog/post/:slug",
    component: _63dd0673
  }, {
    path: "/german/blog/post/:slug",
    component: _63dd0673
  }, {
    path: "/blog/post/:slug",
    component: _63dd0673
  }, {
    path: "/en/post/:slug?",
    component: _63dd0673,
    name: "post-slug___en"
  }, {
    path: "/en/search/:query",
    component: _6f3ea656,
    name: "search-results___en"
  }, {
    path: "/german/post/:slug?",
    component: _63dd0673,
    name: "post-slug___german"
  }, {
    path: "/german/search/:query",
    component: _6f3ea656,
    name: "search-results___german"
  }, {
    path: "/en/:slug+",
    component: _f9c7ec72,
    name: "page___en"
  }, {
    path: "/german/:slug+",
    component: _f9c7ec72,
    name: "page___german"
  }, {
    path: "/post/:slug?",
    component: _63dd0673,
    name: "post-slug___default"
  }, {
    path: "/search/:query",
    component: _6f3ea656,
    name: "search-results___default"
  }, {
    path: "/",
    component: _32e6f417,
    name: "home___default"
  }, {
    path: "/:slug+",
    component: _f9c7ec72,
    name: "page___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
